import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Box, Card, CardContent, Grid, Typography, TextField, IconButton, Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import moment from 'moment';
import 'moment/locale/es';
import compose from 'recompose/compose';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

// Shared components
import Loading from '../../../../../utils/Loading';
import { updateTemplate } from '../../../../../services/Templates';
import Variable from '../../../../../helpers/Template/Variable';
import styles from './styles';

moment.locale('es');

class EditTemplate extends Component {
  constructor(props) {
    super(props);
    const data = this.props.row[1];
    const imgData = data.icono ? data.icono.replace(/ /g, "") : "";
    const img = "data:image/png;base64," + imgData;

    this.state = {
      fieldState: {
        name: data.nombre || "",
        desc: data.descripcion || "",
        code: data.contenido || ""
      },
      id: data.id,
      file: img,
      img: "",
      isLoad: false,
      sucess: false,
      data: data
    };
  }

  handleFieldChange = (field, value) => {
    const { fieldState } = this.state;
    if (field === "upload") {
      const fileImg = value.target.files;
      if (fileImg.length > 0) {
        const file = URL.createObjectURL(fileImg[0]);
        this.setState({
          file: file,
          img: fileImg
        });
      }
    } else {
      const newFieldState = { ...fieldState, [field]: value };
      this.setState({ fieldState: newFieldState });
    }
  };

  save = () => {
    const { t } = this.props;
    const { fieldState, id, file, img } = this.state;
    const user = sessionStorage.getItem("user");
    const token = sessionStorage.getItem("key");

    if (fieldState.name === "" || fieldState.desc === "" || fieldState.code === "") {
      toast.warning(t ? t('templateManager.add.error.0') : 'Es necesario Ingresar Nombre, Descripcion y Codigo');
      return;
    }

    this.setState({ isLoad: true });

    const performUpdate = (imageData) => {
      updateTemplate(id, user, token, fieldState.name, fieldState.desc, imageData, fieldState.code)
        .then(value => {
          if (value === "success") {
            this.setState({ isLoad: false, sucess: true });
            toast.success(t ? t('template.edit.success') : 'Template Actualizado');
            setTimeout(() => { this.props.handleTemplate() }, 2000);
          } else {
            this.setState({ isLoad: false, sucess: false });
            toast.error(t ? t('template.edit.error') : 'Error al actualizar');
          }
        })
        .catch(() => {
          this.setState({ isLoad: false, sucess: false });
          toast.error('Error de conexión');
        });
    };

    if (img !== "") {
      const reader = new FileReader();
      reader.readAsDataURL(img[0]);
      reader.onload = () => {
        const dataImg = reader.result.replace("data:image/png;base64,", '');
        performUpdate(dataImg);
      };
    } else {
      const dataImg = file.replace("data:image/png;base64,", '');
      performUpdate(dataImg);
    }
  };

  render() {
    const { classes, t } = this.props;
    const { isLoad, fieldState, file, data } = this.state;

    return (
      <Card>
        <CardContent>
          <Box display="flex" alignItems="center">
            <IconButton onClick={this.props.handleTemplate} style={{ marginRight: 4 }}>
              <ArrowBackIcon />
            </IconButton>
            <Box>
              <Typography className={classes.textGrey} variant="h4">
                {t ? t('template.edit.title') : 'Editar Template'}
              </Typography>
              <Box display="flex" flexWrap="wrap" marginTop={0.5}>
                <Typography className={classes.textGrey} style={{ marginRight: 16 }} variant="body2">
                  <strong>{t ? t('template.edit.label.createdDate') : 'Creado'}:</strong> {moment(data.fecha_creacion).format("DD/MM/YYYY HH:mm")}
                </Typography>
                <Typography className={classes.textGrey} variant="body2">
                  <strong>{t ? t('template.edit.label.updatedDate') : 'Actualizado'}:</strong> {moment(data.fecha_actualizacion).format("DD/MM/YYYY HH:mm")}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Grid container spacing={2} style={{ marginTop: 8 }}>
            <Grid item xs={12} sm={12} md={6} xl={4}>
              <Box>
                <TextField
                  label={t ? t('template.edit.label.name') : 'Nombre'}
                  name="name"
                  type="text"
                  required
                  value={fieldState.name}
                  onChange={event => this.handleFieldChange('name', event.target.value)}
                  variant="outlined"
                  inputProps={{ maxLength: 40 }}
                  size='small'
                  fullWidth
                />
              </Box>
              <Box marginTop={2}>
                <TextField
                  label={t ? t('template.edit.label.description') : 'Descripción'}
                  name="desc"
                  type="text"
                  required
                  variant="outlined"
                  value={fieldState.desc}
                  onChange={event => this.handleFieldChange('desc', event.target.value)}
                  inputProps={{ maxLength: 40 }}
                  size='small'
                  fullWidth
                  multiline
                  rows={5}
                />
              </Box>
              <Box marginTop={2}>
                <Box className={classes.uploadArea}>
                  <input
                    type="file"
                    onChange={event => this.handleFieldChange('upload', event)}
                    id="upload"
                    accept="image/png"
                    className={classes.fileInput}
                  />
                  <label htmlFor="upload" className={classes.uploadLabel}>
                    <CloudUploadIcon className={classes.uploadIcon} />
                    <Typography variant="body2">Seleccionar imagen</Typography>
                  </label>
                </Box>
                <Box className={classes.imagePreview}>
                  <img className={classes.img} alt="icono" src={file} />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6} xl={4}>
              <Box>
                <TextField
                  style={{ border: "0.2px solid grey" }}
                  label={t ? t('template.edit.label.content') : 'Contenido'}
                  name="code"
                  value={fieldState.code}
                  multiline
                  rows={13}
                  onChange={event => this.handleFieldChange('code', event.target.value)}
                  fullWidth
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} md={6} xl={4}>
              <Box>
                <Variable />
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} md={12} xl={12}>
              <Box marginTop={2} display='flex' justifyContent='right'>
                <Button 
                  disabled={isLoad} 
                  onClick={this.save} 
                  className={classes.buttonSave}
                  variant="contained"
                >
                  {t ? t('template.edit.button.save') : 'Guardar'}
                </Button>
              </Box>
              {isLoad && <Loading />}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default compose(withStyles(styles), withTranslation())(EditTemplate);
